import { memo, useMemo } from 'react';
import {
  BackpackOutlined,
  LuggageOutlined,
  EventSeatOutlined,
  AccessTimeOutlined,
  SwapHorizOutlined,
  MonetizationOnOutlined,
  InfoOutlined,
} from '@mui/icons-material';

export const ServiceIcon = memo(({ category }) => {
  const iconProps = { fontSize: 'small', sx: { mr: 1 } };

  const Icon = useMemo(() => {
    switch (category) {
      case 'HandBaggage':
        return BackpackOutlined;
      case 'Baggage':
        return LuggageOutlined;
      case 'SeatMap':
        return EventSeatOutlined;
      case 'Miscellaneous':
        return AccessTimeOutlined;
      case 'Changes':
        return SwapHorizOutlined;
      case 'Refund':
        return MonetizationOnOutlined;
      default:
        return InfoOutlined;
    }
  }, [category]);

  if (!Icon) return null;
  return <Icon {...iconProps} />;
});
